import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';

@Component({
	selector: 'app-assement',
	templateUrl: './uploadpage.component.html',
	styleUrls: ['./uploadpage.component.css']
})
export class UploadpageComponent implements OnInit {
	success: MatDialogRef<SucesstempComponent>;
	imageURL: string = environment.cloudeImageURL;
	patientid: any;
	public data: Object;
	apiurl = environment.api_url;
	params: any;
	defaultimg: boolean = true;
	terms: number = 0;
	careimagearr;
	modalRef: BsModalRef;
	caredataimg: any;
	patimage: any = {};
	public carepath: any = {};
	public defualtUI: any = './assets/img/users/addusericon.png';
	public myobj1: any = {};
	surgeoninfo: any = [];
	CurrentUser: User;
	userinfo: any;
	constructor(

		private activeroute: ActivatedRoute,
		private routers: Router,
		private patientservice: PatientService,
		private userservice: UserService,
		private modalService: BsModalService,
		private toast: ToastrService,
		private dialog: MatDialog
	) {

	}


	ngOnInit() {

		this.activeroute.params.subscribe(params => {
			this.params = params


		});

		// ////console.log("id",this.params.patid)
		this.userservice.currentUser.subscribe(
			(userData) => {
				this.CurrentUser = userData;
				// this.CurrentUser.status = false
				////console.log(this.CurrentUser.item, "CurrentUser");

			}

		)

		if (this.CurrentUser.item.hostModel == "CLOUD")
			this.imageURL = environment.cloudeImageURL;
		else
			this.imageURL = environment.vmImageURL;


		this.CurrentUser.operationStatus = 'material'
		this.CurrentUser.operationMessage = ''

		if (this.CurrentUser.item) {
			if (this.CurrentUser.item.userimagepath.search("default_") == -1)
				this.defualtUI = this.imageURL + this.CurrentUser.item.userimagepath;
		}
		this.patientservice
			.getimageid(this.params.patid)
			.subscribe(
				data => {
					this.patimage = data;
					//////console.log(this.patimage)
				}
			);

		// this.userservice
		// .postuserinfoid(1,this.CurrentUser.item.userAccountId)

		this.userservice
			.getusersession()
			.subscribe(
				data => {
					this.surgeoninfo = data[0].patientStageWorkflow[0]
					////console.log(this.surgeoninfo)
				}

			);

		//  alert(JSON.parse( window.localStorage['pwd']))

		/* if(window.localStorage['pwd']){
		this.carepath = JSON.parse( window.localStorage['pwd']);
		this.myobj1 = JSON.stringify(this.carepath);
	 
		}
		else{
			this.routers.navigate([`/login`]) 
		} */

	}

	addimgurl(event, passimage) {
		this.defaultimg = false;
		//////console.log("hide" + this.defaultimg);
		let reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);
		reader.onload = (events: any) => {
			this.caredataimg = events.currentTarget.result; // base64      
			//////console.log(event.target.files[0]);
			this.careimagearr = [{
				filename: event.target.files[0].name,
				filetype: event.target.files[0].type,
				value: events.currentTarget.result.split(',')[1]
			}];
			//////console.log(this.careimagearr);
			/* setTimeout(() => {
				 this.addimage(passimage);
			 }, 1000)  */

		}
	}
	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, {
			class: 'modal-sm',
			backdrop: 'static'
		});
	}


	addimage() {
		let uploadimage = this.careimagearr;
		if (this.careimagearr == undefined) {
			uploadimage = [{}];
		}

		let imagevalue = {
			"loginUserName": this.CurrentUser.item.userId,
			"uploadimage": uploadimage,
			"isImageUploadDone": false
		}

		//////console.log("image", imagevalue);


		this.patientservice
			.uploadimage(imagevalue)
			.subscribe(
				data => {


					//////console.log(data);  

					if (data) {
						this.userservice.populate();
						this.routers.navigate([`/patient/dashboard`])
						this.toast.success(this.userservice.translateText('patient_portal.display_messages.image_upload_success'))
						// this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
						// this.success.componentInstance.assessment = 'activity';
						// this.success.componentInstance.message = 'completed';
						this.userservice.logAudit('updateUserUploadImg', 0).subscribe(data => { })

					} else {
						this.toast.error(this.userservice.translateText('patient_portal.display_messages.image_upload_fail'))
						//////console.log("Image Upload Failed")
						// this.resdata = "Image Upload Failed";
						// this.modalRef = this.modalService.show(passimage, {class: 'modal-sm'});    
					}


				}
			);
	}

	goback() {
		this.patientid = window.localStorage['Puser'];
		this.routers.navigate([`/patient/dashboard`])
		/*  this.userservice
		 .goback(this.patientid,'isImageUploadDone')
		 .subscribe(
			 data => {
			 if(data){
				 this.routers.navigate([`/patient/dashboard`])
				 
			 }
			 }
		 ); */
	}
}